export default [
    {
        // MUST BE CHANGED TO GET REPORT TYPES FROM THE API
        label: 'Reports',
        trans: 'crewman::employee.title.reports.reports',
        route: '/reports',
        icon: 'fal fa-list-ul',
        badge: 0,
        display: true,
        default: false,
        subItems: [
            {
                label: 'Overview',
                trans: 'crewman::employee.title.reports.overview',
                route: '/reports/list',
                icon: 'fal fa-list-ul',
                badge: 0,
                display: true,
                default: false
            },
            {
                label: 'Incident & Deviation',
                trans: 'crewman::employee.title.reports.incident_deviation',
                route: '/reports/create/incident-deviation',
                icon: 'fal fa-exclamation-circle',
                badge: 0,
                display: true,
                default: false
            },
            {
                label: 'Daily Flight Performance',
                trans: 'crewman::employee.title.reports.daily_flight',
                route: '/reports/create/daily-flight',
                icon: 'fal fa-plane',
                badge: 0,
                display: true,
                default: false
            },
            {
                label: 'Fatigue',
                trans: 'crewman::employee.title.reports.fatigue',
                route: '/reports/create/fatigue',
                icon: 'fal fa-battery-bolt',
                badge: 0,
                display: true,
                default: false
            },
            {
                label: 'Occupational Accident',
                trans: 'crewman::employee.title.reports.occupational_accident',
                route: '/reports/create/occupational-accident',
                icon: 'fal fa-chart-line',
                badge: 0,
                display: true,
                default: false
            },
            {
                label: 'Performance Review',
                trans: 'crewman::employee.title.reports.performance_review',
                route: '/reports/create/performance-review',
                icon: 'fal fa-chart-line',
                badge: 0,
                display: true,
                default: false
            },
        ]
    },
    {
        // MUST BE CHANGED TO GET REQUEST TYPES FROM THE API
        label: 'Requests',
        trans: 'crewman::employee.title.requests.requests',
        route: '/requests',
        icon: 'fal fa-plus-square',
        badge: 0,
        display: true,
        default: false,
        subItems: [
            {
                label: 'Overview',
                trans: 'crewman::employee.title.requests.overview',
                route: '/requests/list',
                icon: 'fal fa-plus-square',
                badge: 0,
                display: true,
                default: false
            },
            {
                label: 'Buddy Flying',
                trans: 'crewman::employee.title.requests.buddy_flying',
                route: '/requests/create/buddy-flying',
                icon: 'fal fa-user-friends',
                badge: 0,
                display: true,
                default: false
            },
            {
                label: 'Days Off',
                trans: 'crewman::employee.title.requests.days_off',
                route: '/requests/create/days-off',
                icon: 'fal fa-calendar-check',
                badge: 0,
                display: true,
                default: false
            },
            {
                label: 'Duty Swap',
                trans: 'crewman::employee.title.requests.duty_swap',
                route: '/requests/create/duty-swap',
                icon: 'fal fa-exchange',
                badge: 0,
                display: true,
                default: false
            },
            {
                label: 'Pattern Flying',
                trans: 'crewman::employee.title.requests.pattern_flying',
                route: '/requests/create/pattern-flying',
                icon: 'fal fa-sort-amount-down',
                badge: 0,
                display: true,
                default: false
            },
            {
                label: 'Reservist Service',
                trans: 'crewman::employee.title.requests.reservist_service',
                route: '/requests/create/reservist-service',
                icon: 'fal fa-tag',
                badge: 0,
                display: true,
                default: false
            },
            {
                label: 'Child Care Leave',
                trans: 'crewman::employee.title.requests.child_care_leave',
                route: '/requests/create/child-care-leave',
                icon: 'fal fa-child',
                badge: 0,
                display: true,
                default: false
            },
            {
                label: 'Annual Leave',
                trans: 'crewman::employee.title.requests.annual_leave',
                route: '/annual-leave',
                icon: 'fal fa-copy',
                badge: 0,
                display: true,
                default: false
            },
        ]
    },
    {
        label: 'Support',
        trans: 'crewman::employee.title.support.support',
        route: '/support',
        icon: 'fal fa-question-circle',
        badge: 0,
        display: true,
        default: false,
        subItems: [
            {
                label: 'HR',
                trans: 'crewman::employee.title.support.hr',
                route: '/support/HR',
                icon: 'fal fa-user-cog',
                badge: 0,
                display: true,
                default: false
            },
            {
                label: 'Payroll',
                trans: 'crewman::employee.title.support.payroll',
                route: '/support/Payroll',
                icon: 'fal fa-file-invoice-dollar',
                badge: 0,
                display: true,
                default: false
            },
            {
                label: 'IT',
                trans: 'crewman::employee.title.support.it',
                route: '/support/IT',
                icon: 'fal fa-desktop',
                badge: 0,
                display: true,
                default: false
            },
            {
                label: 'Other',
                trans: 'crewman::employee.title.support.other',
                route: '/support/Other',
                icon: 'fal fa-question-square',
                badge: 0,
                display: true,
                default: false
            },
        ]
    },
    {
        label: 'Profile',
        trans: 'crewman::employee.title.employee.profile',
        route: '/profile',
        icon: 'fal fa-user-alt',
        badge: 0,
        display: true,
        default: false,
        subItems: [
            {
                label: 'Personal',
                trans: 'crewman::employee.title.employee.personal',
                route: '/profile/personal',
                icon: 'fal fa-user-edit',
                badge: 0,
                display: true,
                default: false
            },
            {
                label: 'Contact',
                trans: 'crewman::employee.title.employee.contact',
                route: '/profile/contact',
                icon: 'fal fa-map-marker-alt',
                badge: 0,
                display: true,
                default: false
            },
            {
                label: 'Emergency Contacts',
                trans: 'crewman::employee.title.employee.emergency_contacts',
                route: '/profile/emergency-contacts',
                icon: 'fal fa-phone',
                badge: 0,
                display: true,
                default: false
            },
            {
                label: 'Bank',
                trans: 'crewman::employee.title.employee.bank',
                route: '/profile/bank',
                icon: 'fal fa-money-check-alt',
                badge: 0,
                display: true,
                default: false
            },
            {
                label: 'Pension',
                trans: 'crewman::employee.title.employee.pension',
                route: '/profile/pension',
                icon: 'fal fa-piggy-bank',
                badge: 0,
                display: true,
                default: false
            },
            {
                label: 'Work Details',
                trans: 'crewman::employee.title.employee.work_details',
                route: '/profile/work-details',
                icon: 'fal fa-info',
                badge: 0,
                display: true,
                default: false
            },
            {
                label: 'Health Insurance',
                trans: 'crewman::employee.title.employee.health_insurance',
                route: '/profile/health-insurance',
                icon: 'fal fa-heartbeat',
                badge: 0,
                display: true,
                default: false
            },
        ]
    },
    {
        label: 'Newsletters',
        trans: 'crewman::employee.title.newsletters',
        route: '/newsletters',
        icon: 'fal fa-newspaper',
        badge: 0,
        display: true,
        default: false,
        subItems: []
    },
    {
        label: 'Expenses',
        trans: 'crewman::employee.title.expenses',
        route: '/expenses',
        icon: 'fal fa-wallet',
        badge: 0,
        display: true,
        default: false,
        subItems: []
    },
    {
        label: 'Documents',
        trans: 'crewman::employee.title.documents.documents',
        route: '/documents',
        icon: 'fal fa-copy',
        badge: 0,
        display: true,
        default: false,
        subItems: []
    },
    {
        label: 'Company Docs',
        trans: 'crewman::employee.title.handbooks',
        route: '/handbooks',
        icon: 'fal fa-book-open',
        badge: 0,
        display: true,
        default: false,
        subItems: []
    },
    {
        label: 'Insurances',
        trans: 'crewman::employee.title.insurances',
        route: '/insurances',
        icon: 'fal fa-shield-check',
        badge: 0,
        display: true,
        default: false,
        subItems: []
    },
    {
        label: 'Annual Leave',
        trans: 'crewman::employee.title.annual_leave',
        route: '/annual-leave',
        icon: 'fal fa-calendar-alt',
        badge: 0,
        display: false,
        default: false,
        subItems: []
    },
    {
        label: 'Roster',
        trans: 'crewman::employee.title.roster',
        route: '/roster',
        icon: 'fal fa-plane-alt',
        badge: 0,
        display: false,
        default: false,
        subItems: []
    },
    {
        label: 'My Account',
        trans: 'crewman::employee.title.account',
        route: '/account',
        icon: 'fal fa-cog',
        badge: 0,
        display: false,
        default: false,
        subItems: []
    },
    {
        label: 'Leaves',
        trans: 'crewman::employee.title.leaves',
        route: '/leaves',
        icon: 'fal fa-calendar-check',
        badge: 0,
        display: true,
        default: false,
        subItems: []
    },
    {
        label: 'Payroll',
        trans: 'crewman::employee.title.pay_roll.pay_roll',
        route: '/pay-roll',
        icon: 'fal fa-file-invoice-dollar',
        badge: 0,
        display: true,
        default: false,
        subItems: [
            {
                label: 'Payslips',
                trans: 'crewman::employee.title.pay_roll.pay_slips',
                route: '/pay-roll/pay-slips',
                icon: 'fal fa-file-invoice-dollar',
                badge: 0,
                display: true,
                default: false
            },
            {
                label: 'CloudPay',
                trans: 'crewman::employee.title.pay_roll.cloudpay',
                route: '/pay-roll/cloudpay',
                icon: 'fal fa-file-invoice-dollar',
                badge: 0,
                display: true,
                default: false
            },
        ]
    },
    {
        label: 'Crew',
        trans: 'crewman::employee.title.crew',
        route: '/employees',
        icon: 'fal fa-users',
        badge: 0,
        display: true,
        default: false,
        subItems: []
    },
    {
        label: 'Timesheets',
        trans: 'crewman::employee.title.timesheets',
        route: '/timesheets',
        icon: 'fal fa-clock',
        badge: 0,
        display: true,
        default: false,
        subItems: []
    },
]
